import React from 'react';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Header from 'components/Header';
import CalculatorDialog from 'components/Loans/CalculatorDialog';
import QuoteDialog from 'components/Loans/QuoteDialog';
import { fetchQuotes } from 'actions/quotes';
import { dollars } from 'utils/money';
import { isEmpty } from 'lodash';
import { date } from 'utils/date';

class Quotes extends React.Component {
  componentWillMount = () => {
    const { organisation, dispatch } = this.props;
    dispatch(fetchQuotes(organisation.id));
  }

  renderQuotesTable = () => {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Quote number</TableCell>
            <TableCell>Principal</TableCell>
            <TableCell>Rate</TableCell>
            <TableCell>Application fee</TableCell>
            <TableCell>Term length</TableCell>
            <TableCell>Drawdown date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.props.quotes && this.renderQuotes()}
        </TableBody>
      </Table>
    );
  }

  renderQuotes = () => {
    const { quotes } = this.props;
    return quotes.map(quote => (
      <TableRow key={quote.id}>
        <TableCell>
          <QuoteDialog
            quote={quote}
            buttonLabel={quote.quoteNumber}
          />
        </TableCell>
        <TableCell>
          {dollars(quote.principal)}
        </TableCell>
        <TableCell>
          {`${quote.interestRate}%`}
        </TableCell>
        <TableCell>
          {dollars(quote.establishmentFee)}
        </TableCell>
        <TableCell>
          {`${quote.termLength} ${quote.termUnit}`}
        </TableCell>
        <TableCell>
          {date(quote.drawdownDate)}
        </TableCell>
      </TableRow>
    ));
  }

  render = () => {
    const { organisation, fetching } = this.props;
    return (
      <div>
        <Header heading='Quotes'>
          <CalculatorDialog
            organisationId={organisation.id}
            buttonLabel='NEW QUOTE'
          />
        </Header>
        <Divider />
        <ListItem>
          {
            fetching
            ? <CircularProgress size={50} />
            : isEmpty(this.props.quotes)
              ? 'N/A'
              : this.renderQuotesTable()
          }
        </ListItem>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const orgId = ownProps.organisation.id;
  const { quotes } = state.organisations[orgId];
  const { fetching } = state.quotes;
  return { quotes, fetching };
};

const reduxed = connect(mapStateToProps)(Quotes)
export default withStyles({})(reduxed)



// WEBPACK FOOTER //
// ./src/components/Organisations/Quotes.js